// @ts-nocheck whole file

import {
    ChildCostAllocation,
    ChildSettlementId,
    CostAllocationFormFields,
    ManualBillCostCategory,
} from 'types';
import { parseBankAccountNumberIntoFormattedBankAccountNumber } from 'utils/parsers/bankAccountNumber/parseBankAccountNumberIntoFormattedBankAccountNumber';

export const parseCostAllocationDTOToCostAllocationFormFields = (
    costAllocation: ChildCostAllocation,
): CostAllocationFormFields => ({
    monthlySettlementId: '' as ChildSettlementId,
    correctionId: '',
    additionalCostId: '',
    specificAmount: 0,
    percentageAmount: 0,
    refersTo: '',
    refersToCourses: [],
    foundationName: '',
    type: '',
    payerType: '',
    nip: '',
    street: '',
    city: '',
    zipCode: '',
    invoiceNotes: costAllocation.invoiceNotes ?? '',
    costCategory: ManualBillCostCategory.STARTER_KIT,
    sourceType: '',
    splitType: '',
    bankAccountNumber: costAllocation.bankAccountNumber
        ? parseBankAccountNumberIntoFormattedBankAccountNumber(costAllocation.bankAccountNumber)
        : '',
});

export const parseCostAllocationDTOToCostAllocationFormFieldsV2 = (
    costAllocation: ChildCostAllocation,
): CostAllocationFormFields => ({
    ...costAllocation,
    specificAmount: costAllocation.entryGrossAmount ?? 0,
    refersTo: (costAllocation.costCategory ?? '') as ManualBillCostCategory,
    refersToCourses: costAllocation.courseList ?? [],
    nip: costAllocation.nip ?? '',
    type: costAllocation.splitType ?? '',
    street: costAllocation.address?.street ?? '',
    city: costAllocation.address?.city ?? '',
    zipCode: costAllocation.address?.zipCode ?? '',
    bankAccountNumber: costAllocation.bankAccountNumber
        ? parseBankAccountNumberIntoFormattedBankAccountNumber(costAllocation.bankAccountNumber)
        : '',
});
